<template>
<component v-bind:is="layout"></component>
</template>

<style>


@import "../node_modules/leaflet/dist/leaflet.css";

.leaflet-fake-icon-image-2x {
  background-image: url(../node_modules/leaflet/dist/images/marker-icon-2x.png);
}
.leaflet-fake-icon-shadow {
  background-image: url(../node_modules/leaflet/dist/images/marker-shadow.png);
}
</style>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/css/vue-select.css'
import AppLayout from './layouts/AppLayout'
import LoginLayout from './layouts/LoginLayout'
import axios from 'axios'
import config from '@/config.js'
import auth from '@/auth.js'

// TODO сделать проверку на версию APP и принудительно перезагружать в случае отличия
export default {
    name: 'App',
    mounted() {
        auth.checkLogin()
        this.setinreval_checkLogin = setInterval(() => {
            auth.checkLogin()
        }, 120000);
    },
    data() {
        return {
            setinreval_checkLogin: null
        }
    },
    computed: {
        layout() {
            return this.$store.getters.layout
        }
    },
    components: {
        'app-layout': AppLayout,
        'login-layout': LoginLayout,
    },
    destroyed() {
        clearInterval(this.setinreval_checkLogin)
    },
}
</script>



// WEBPACK FOOTER //
// src/App.vue